export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CREST_MOTTO = 'AETERNITAS ET VERITAS';
export const DARK_MOTTO = 'PER SANGUINEM IMMORTALIS';

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1542632845-622cdd6f5d2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  parchment: 'https://images.unsplash.com/photo-1595232208179-d8cf4ca455fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxvbGQlMjBwYXBlciUyMHBhcmNobWVudCUyMG1hcCUyMHRleHR1cmUlMjB2aW50YWdlfGVufDB8fHx8MTc5MTI0OTY1NHww&ixlib=rb-4.1.0&q=85',
};

export const SIBLINGS = [
  {
    id: 'octavious',
    name: 'Octavious León',
    domain: 'Mayor of St. Bellmore',
    secretRole: 'Warden of the Bellmore Mandate',
    bio: 'Custodian of the town charter and its oldest agreements. The council has never missed a quorum — nor changed its minutes.',
    portrait: 'https://customer-assets-cm19k8pv.emergentagent.net/job_occult-secrets/artifacts/6w7f8sk5_20ba75d5-d430-4080-bc44-e77e2e5b2f0e.png',
  },
  {
    id: 'solene',
    name: 'Solène León',
    domain: 'Founder & Chair · León Biotech',
    secretRole: 'High Priestess of the Alchemical Transmutation',
    bio: 'Maker of the Longevity Programme’s therapies. Her formulas stay proprietary; her patients stay alive.',
    portrait: 'https://customer-assets-cm19k8pv.emergentagent.net/job_occult-secrets/artifacts/c8rn8t38_2f83824d-a398-4c9c-a7b5-5efe0734424a.png',
  },
  {
    id: 'maeve',
    name: 'Maeve León',
    domain: 'President · St. Bellmore Institute of Arts & Sciences',
    secretRole: 'Keeper of the Celestial Sigils & Geometry',
    bio: 'Directs the Brentwood laboratories. Her work runs a century ahead of the journals.',
    portrait: 'https://customer-assets-cm19k8pv.emergentagent.net/job_occult-secrets/artifacts/huxeuclb_55e514a3-38e4-43e8-bb08-811e85f237d6.png',
  },
  {
    id: 'henrietta',
    name: 'Henrietta León',
    domain: 'Managing Partner · León & Associates',
    secretRole: 'Arch-Magister of Treaties & the Public Veil',
    bio: 'Architect of the Bellmore Charitable Trust Acts. Her trusts have outlived every challenger since 1842.',
    portrait: 'https://customer-assets-cm19k8pv.emergentagent.net/job_occult-secrets/artifacts/416irjzy_64d90c10-09fd-4372-b654-0607ce237947.png',
  },
];

export const PILLARS = [
  {
    id: 'legal',
    index: '01',
    field: 'Legal',
    title: 'Precedent Without Expiry',
    body: 'León & Associates drafted the Bellmore Charitable Trust Acts — cited in forty jurisdictions, in force since 1842.',
    stat: '184 yrs of unbroken counsel',
  },
  {
    id: 'medical',
    index: '02',
    field: 'Medical',
    title: 'The Longevity Programme',
    body: 'León Biotech’s regeneration therapies have run for generations. Patients report vitality their physicians call impossible.',
    stat: '12,000+ trial participants',
  },
  {
    id: 'scientific',
    index: '03',
    field: 'Scientific',
    title: 'Resonance & Matter',
    body: 'Our Brentwood laboratories probe quantum resonance and the geometry of matter. The journals call it a century ahead of its time.',
    stat: '47 patents held in perpetuity',
  },
];

export const LOCATIONS = [
  {
    id: 'mansion',
    name: 'León Mansion',
    subtitle: 'Overlooking St. Bellmore Bluff',
    icon: 'castle',
    coords: { x: 50, y: 18 },
    entry: 'I',
    secretTitle: 'The Sanctum Sanctorum & Ancestral Ritual Chamber',
    secretLore: 'The mansion is no residence but an instrument, built on the old ley-line intersection. Its tower holds the Eternal Flame — lit in 1842, never extinguished.',
    secretLore2: 'Each solstice the Four convene in the sub-cellar. The town reports only “a private dinner.” It has reported this for 184 years.',
    keeper: 'The Four, convened',
    videoId: 'd9MyW72ELq0',
    image: 'https://images.unsplash.com/photo-1542632845-622cdd6f5d2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'town_hall',
    name: 'St. Bellmore Town Hall',
    subtitle: 'Civic Administration & Records',
    icon: 'landmark',
    coords: { x: 30, y: 45 },
    entry: 'II',
    secretTitle: 'The Archival Veil & Municipal Puppet Registry',
    secretLore: 'Every mayor and clerk for 140 years has been a sworn initiate. Elections here are not decided — they are transcribed.',
    secretLore2: 'A lead vault below holds forty-one León death certificates, each superseded by a later birth. The paper ages. The names do not.',
    keeper: 'Octavious León',
    videoId: 'L_LUpnjgPso',
    image: 'https://images.unsplash.com/photo-1619904253375-23310eaf449b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'library',
    name: 'St. Bellmore Public Library',
    subtitle: 'Historical Archives & Literature',
    icon: 'library',
    coords: { x: 70, y: 42 },
    entry: 'III',
    secretTitle: 'The Forbidden Atrium of Grimoires',
    secretLore: 'Past a catalogue drawer found on no floor plan lies the true collection: codices of alchemy, alignment and binding.',
    secretLore2: 'The oldest volume, the Bellmore Bestiary, ends in a blank chapter. Its ink is fresh.',
    keeper: 'Henrietta León',
    videoId: '4Ktz7a0y_bU',
    image: 'https://images.unsplash.com/photo-1616163527093-41acfce459ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'hospital',
    name: 'St. Bellmore Memorial Hospital',
    subtitle: 'Medical Research Wing',
    icon: 'hospital',
    coords: { x: 25, y: 70 },
    entry: 'IV',
    secretTitle: 'The Biological Harvest & Elixir Synthesis Lab',
    secretLore: 'Trial patients receive the finest care — and unknowingly donate the plasma Solène refines into the Continuance.',
    secretLore2: 'Ward C appears in no directory. Its patients were discharged decades ago. Its lights burn every night.',
    keeper: 'Solène León',
    videoId: '2Vv-BfVoq4g',
    image: 'https://images.unsplash.com/photo-1619904252549-88d890e7455b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'college',
    name: 'Brentwood College',
    subtitle: 'Department of Physics & Law',
    icon: 'graduation',
    coords: { x: 75, y: 68 },
    entry: 'V',
    secretTitle: 'The Order of the Silver Quill',
    secretLore: 'The Order takes Brentwood’s brightest and trains them in litigation, discretion and obedience.',
    secretLore2: 'Initiates swear at midnight beneath Maeve’s orrery — which has never agreed with the published stars.',
    keeper: 'Maeve León',
    videoId: 'd9MyW72ELq0',
    image: 'https://images.unsplash.com/photo-1542632845-622cdd6f5d2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'station',
    name: 'Police & Fire Central Station',
    subtitle: 'Emergency & Public Safety',
    icon: 'siren',
    coords: { x: 48, y: 55 },
    entry: 'VI',
    secretTitle: 'The Enforcers of Silence & Evidence Disposal',
    secretLore: 'Every unexplained report routes to one desk, classified and purged within the hour.',
    secretLore2: 'The roster lists forty-one officers. The building sleeps twelve. No journalist has reconciled the difference twice.',
    keeper: 'Octavious León',
    videoId: 'L_LUpnjgPso',
    image: 'https://images.unsplash.com/photo-1619904253375-23310eaf449b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'sawmill',
    name: 'St. Bellmore Timber Mill',
    subtitle: 'Industrial Works & Forestry',
    icon: 'axe',
    coords: { x: 52, y: 82 },
    entry: 'VII',
    secretTitle: 'The Subterranean Foundry & Relic Excavation',
    secretLore: 'By night the freight lift descends to a pre-colonial quarry, raising relics no museum will ever record.',
    secretLore2: 'Shipments are weighed twice. The difference — constant since 1888 — is one stone sarcophagus a month.',
    keeper: 'Henrietta León',
    videoId: '4Ktz7a0y_bU',
    image: 'https://images.unsplash.com/photo-1616163527093-41acfce459ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZ290aGljJTIwbW9vZHklMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvciUyMG15c3Rlcnl8ZW58MHx8fHwxNzkxMjQ5NjU0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'sydney',
    name: 'Sydney — The Harbour Outpost',
    subtitle: 'Beneath the South Pylon',
    icon: 'anchor',
    coords: { x: 88, y: 83 },
    entry: 'VIII',
    secretTitle: 'The Pylon Vault & the Southern Watch',
    secretLore: 'In 1932 the Conclave sealed a vault inside the south-east pylon — and has watched every ship enter the harbour since.',
    secretLore2: 'The pylon’s third lift drops twelve metres below the harbour bed. Ask why it hums at slack tide. The answer is “the wind.”',
    keeper: 'Solène León',
    videoId: '2Vv-BfVoq4g',
    image: 'https://images.unsplash.com/photo-1512477525059-e0b091e0a9ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MDV8MHwxfHNlYXJjaHwzfHxzeWRuZXklMjBoYXJib3VyJTIwZGFyayUyMG5pZ2h0fGVufDB8fHx8MTc5MTI1NzEwNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'graveyard',
    name: 'The Old Graveyard & Hollow Chapel',
    subtitle: 'Consecrated 1791',
    icon: 'church',
    coords: { x: 33, y: 28 },
    entry: 'IX',
    secretTitle: 'The Boneyard Gate & the Chapel of Empty Tombs',
    secretLore: 'Forty-one León graves, kept in fresh flowers, with no bodies beneath.',
    secretLore2: 'On each recorded death a grave opens by night and closes by morning. The oldest stone bears no name — only an ouroboros, worn smooth.',
    keeper: 'The Four, interred & risen',
    videoId: 'L_LUpnjgPso',
    image: 'https://images.unsplash.com/photo-1707051772724-d976e49c785b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxncmF2ZXlhcmQlMjBmb2d8ZW58MHx8fHwxNzkxMjYwNjk2fDA&ixlib=rb-4.1.0&q=85',
  },
];

export const MARQUEE_ITEMS = [
  'Jurisprudence',
  'Cellular Longevity',
  'Quantum Science',
  'Civic Heritage',
  'Est. 1842',
  'St. Bellmore',
];
